import angular from "angular"

export var $uniUP = angular.module("UP", ["UniBase"])

export function Foo2(test: string) {
  return {}
}

require("./directives")
require("./components")
